import { BishopDetails } from '../models/new-hire-model';

function FormatBishopName(bishopDetail: any) : string {
    if (!bishopDetail) return '';

    const nameParts = [];

    if (bishopDetail.suffix){
        nameParts.push(bishopDetail.suffix);
    }

    if (bishopDetail.first_name){
        nameParts.push(bishopDetail.first_name);
    }

    if (bishopDetail.middle_name){
        nameParts.push(bishopDetail.middle_name);
    }

    if (bishopDetail.last_name){
        nameParts.push(bishopDetail.last_name);
    }

    return nameParts.join(' ');
}

export function GetDioceseLicensedInOptions(data: BishopDetails[]): any[] {
    if (!data) return null;

    return data.map(
        item => {
            return {
                text: item.name,
                value: item.client_number,
            };
    });
}	

export function GetLicensedByOptions(bishopDetails: BishopDetails[], selectedDioceseLicensedId: string): any[] {
    if (!selectedDioceseLicensedId || !bishopDetails || bishopDetails?.length === 0) return [];

    const dioceseDetail = bishopDetails.find(item=> item.client_number === selectedDioceseLicensedId);

    if (dioceseDetail){
        const mappedList = dioceseDetail.bishop?.map(
            item=>{
                return {
                    text: FormatBishopName(item),
                    value: item.guid,
                };
            });

        return mappedList;
    }

    return [];
}	